import { FooterLink } from "@/types/footerLink"

export const bettingTools = (dictionary: any) : FooterLink[] => {
  return [
    {
      id: 1,
      title: dictionary.page.home.footer["trading"],
      href: "/tools/trade",
      newTab: false,
    },
    {
      id: 2,
      title: dictionary.page.home.footer["bet_tracker"],
      href: "/tools/tracker/dashboard",
      newTab: false,
    },
    {
      id: 3,
      title: dictionary.page.home.footer["positive_ev"],
      href: "/tools/positive-ev",
      newTab: false,
    },
    {
      id: 5,
      title: dictionary.page.home.footer["accumulator"],
      href: "/more-tools/accumulator",
      newTab: false,
    },
    {
      id: 6,
      title: dictionary.page.home.footer["arbitrage"],
      href: "/tools/arbitrage",
      newTab: false,
    },
    {
      id: 7,
      title: dictionary.tool.ev_simulator["title"],
      href: "/more-tools/ev-simulator",
      newTab: false,
    },
    {
      id: 8,
      title: dictionary.page.home.footer["ai_agents"],
      href: "/polymarket-ai-agent",
      newTab: false,
    },
  ];
}

export const companiesLink = (dictionary: any) : FooterLink[] => {
  return [
    {
      id: 2,
      title: dictionary.page.home.footer["about"],
      href: "/about",
      newTab: false,
    },
    {
      id: 5,
      title: dictionary.navigation["pricing"],
      href: "/pricing",
      newTab: false,
    },
    {
      id: 6,
      title: dictionary.page.home.footer["docs"],
      href: "/docs",
      newTab: false,
    },
    {
      id: 2,
      title: dictionary.page.home.footer["privacy"],
      href: "/privacy-policy",
      newTab: false,
    },
    {
      id: 3,
      title: dictionary.page.home.footer["terms"],
      href: "/terms-and-conditions",
      newTab: false,
    },
    {
      id: 4,
      title: dictionary.page.home.footer["supported_bookmakers"],
      href: "/supported_bookmakers",
      newTab: false,
    },
    {
      id: 7,
      title: dictionary.page.home.footer["methodology"],
      href: "/methodology",
      newTab: false,
    }
  ];
}

export const bettingAids = (dictionary: any) : FooterLink[] => {
  return [
    {
      id: 1,
      title: dictionary.page.home.footer["risk_calculator"],
      href: "/calculators/risk-calculator",
      newTab: false,
    },
    {
      id: 3,
      title: dictionary.page.home.footer["vig_calculator"],
      href: "/calculators/vig-calculator",
      newTab: false,
    },
    {
      id: 2,
      title: dictionary.page.home.footer["ev_calculator"],
      href: "/calculators/ev-calculator",
      newTab: false,
    },
    {
      id: 4,
      title: dictionary.page.home.footer["kelly_calculator"],
      href: "/calculators/kelly-calculator",
      newTab: false,
    },
    {
      id: 5,
      title: dictionary.page.home.footer["arbitrage_calculator"],
      href: "/calculators/arb-calculator",
      newTab: false,
    },
    {
      id: 6,
      title: dictionary.calculators.odds_to_probability_calculator["title"],
      href: "/calculators/odds-to-probability-calculator",
      newTab: false,
    },
    {
      id: 7,
      title: dictionary.page.home.footer["hedge_calculator"],
      href: "/calculators/hedge-calculator",
      newTab: false,
    },
    {
      id: 8,
      title: dictionary.page.home.footer["buy_odds_converter"],
      href: "/calculators/buy-odds-converter",
      newTab: false,
    },
    {
      id: 9,
      title: dictionary.calculators.kalshi_polymarket_fee_calculator["title"],
      href: "/calculators/kalshi-polymarket-fee-calculator",
      newTab: false,
    }
  ];
}